<main class="bg-black text-white min-h-screen overflow-x-hidden">
  <section class="relative min-h-[65vh] flex items-center pt-24 pb-14 overflow-hidden page-hero-gradient">
    <div class="absolute -top-48 right-0 w-[700px] h-[700px] bg-varroc-accent/5 rounded-full blur-3xl"></div>
    <div class="absolute inset-0 opacity-[0.025]" style="background-image: linear-gradient(rgba(0,170,230,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(0,170,230,0.5) 1px, transparent 1px); background-size: 60px 60px;"></div>

    <div class="relative z-10 max-w-7xl mx-auto px-6 w-full">
      <div class="max-w-5xl">
        <a routerLink="/products/connectiq" class="back-nav" data-aos="fade-down">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4 svg-stroke-gradient"><polyline points="15 18 9 12 15 6"></polyline></svg>
          Back to ConnectIQ
        </a>
        <h1 class="hero-col font-black mb-5" data-aos="fade-up" data-aos-delay="100">
          OEM In Vehicle App Marketplace <span class="text-varroc-accent">Native, Governed, and Monetizable</span>
        </h1>
        <p class="text-varroc-text-gray text-lg leading-relaxed mb-8 max-w-3xl" data-aos="fade-up" data-aos-delay="200">
          Varroc Connect enables OEMs to curate, distribute, update, and monetize in-vehicle apps with full control over governance, security, and user experience.
        </p>
      </div>
    </div>
  </section>

  <nav class="sticky-product-nav">
    <div class="max-w-7xl mx-auto px-6">
      <div class="flex overflow-x-auto">
        <a *ngFor="let s of sections" (click)="scrollTo(s.id)" [class.active]="activeSection === s.id" class="cursor-pointer flex-shrink-0">
          <i class='bx text-base' [class]="s.icon"></i> {{ s.label }}
        </a>
      </div>
    </div>
  </nav>

  <div class="max-w-7xl mx-auto px-6 py-20 space-y-28">
    <section id="overview" class="section-anchor">
      <div class="grid lg:grid-cols-[1.1fr,0.9fr] gap-10 items-start">
        <div data-aos="fade-right">
          <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Overview</span>
          <h2 class="text-4xl font-black mt-2 mb-4">A Marketplace Layer Built for OEM Ownership</h2>
          <p class="text-varroc-text-gray text-lg leading-relaxed mb-5">The Vehicle App Store is designed to operate inside the OEM-native IVI layer, allowing the brand to control the full application lifecycle without handing the experience to external consumer platforms.</p>
          <p class="text-varroc-text-gray leading-relaxed">That model preserves digital ownership across listing, release, monetization, analytics, and policy enforcement while still allowing OEMs to coexist with broader ecosystems where needed.</p>
        </div>
        <div class="grid sm:grid-cols-3 gap-5" data-aos="fade-left">
          <div *ngFor="let item of overviewHighlights" class="feature-card text-left">
            <div class="text-varroc-accent font-black text-base xl:text-xl leading-tight whitespace-nowrap pr-2 mb-2">
              {{ item.val }}
            </div>
            <div class="text-varroc-text-gray text-sm leading-relaxed">{{ item.label }}</div>
          </div>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="features" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Control Model</span>
        <h2 class="text-4xl font-black mt-2 mb-4">OEM Control by Design</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">The marketplace architecture is built so governance, delivery, monetization, and ecosystem policy remain in OEM hands instead of being outsourced to a third-party store model.</p>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        <div *ngFor="let item of features; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="item.icon"></i>
          </div>
          <h3 class="text-white font-bold text-lg mb-3">{{ item.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="categories" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Value Proposition</span>
        <h2 class="text-4xl font-black mt-2 mb-4">What the Marketplace Unlocks for OEMs</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">Beyond app distribution, the marketplace creates a digital operating model for ownership, speed, service innovation, and scalable post-sale monetization.</p>
      </div>
      <div class="grid md:grid-cols-2 xl:grid-cols-3 gap-6">
        <div *ngFor="let item of categories; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 60).toString()">
          <div class="w-11 h-11 bg-varroc-accent/15 rounded-xl flex items-center justify-center mb-4">
            <i class='bx icon-gradient text-xl' [class]="item.icon"></i>
          </div>
          <h3 class="text-white font-bold text-lg mb-3">{{ item.name }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ item.count }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="developers" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Strategic Outcome</span>
        <h2 class="text-4xl font-black mt-2 mb-4">From Static Vehicle Delivery to a Software-Defined Platform</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">The Vehicle App Store helps OEMs move beyond one-time delivery into a continuously evolving digital platform model, with tighter customer engagement, differentiated services, and durable revenue potential.</p>
      </div>
      <div class="grid md:grid-cols-2 gap-6">
        <div *ngFor="let item of devSteps; let i = index" class="feature-card" [attr.data-aos]="'fade-up'" [attr.data-aos-delay]="(i * 70).toString()">
          <div class="text-varroc-accent font-black text-sm tracking-[0.3em] uppercase mb-3">{{ item.step }}</div>
          <h3 class="text-white font-bold text-lg mb-3">{{ item.title }}</h3>
          <p class="text-varroc-text-gray text-sm leading-relaxed">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <div class="accent-divider"></div>

    <section id="workflow" class="section-anchor">
      <div class="mb-12" data-aos="fade-up">
        <span class="text-varroc-accent text-sm font-bold uppercase tracking-widest">Workflow</span>
        <h2 class="text-4xl font-black mt-2 mb-4">In-Vehicle App Marketplace Workflow</h2>
        <p class="text-varroc-text-gray max-w-3xl mr-auto">A visual flow of how the OEM-native marketplace handles governance, partner participation, app lifecycle management, distribution, and monetization inside the in-vehicle ecosystem.</p>
      </div>
      <div class="feature-card overflow-hidden" data-aos="fade-up">
        <img [src]="workflowImage" alt="In-vehicle app marketplace workflow diagram" class="w-full h-auto rounded-xl block">
      </div>
    </section>

  </div>
</main>
